const firebaseConfig = {
    apiKey: "AIzaSyDnSb9UomAWKAVc1MX4XaI3xE2k5VMKAoo",
    authDomain: "susastho-bd.firebaseapp.com",
    projectId: "susastho-bd",
    storageBucket: "susastho-bd.appspot.com",
    messagingSenderId: "62403117217",
    appId: "1:62403117217:web:8cb813399520f31c5470e0"
  };

  export default firebaseConfig;